
import { HttpCarrierList } from '@/service/basicdata';
import TableList from "@components/templates/tablelist";
// import { mapGetters } from 'vuex';
import mixin from "./mixin";
export default {
    mixins: [TableList, mixin],
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
        };
    },
    methods: {
        ajaxRequest: HttpCarrierList,
        // handleOperates(params, type) {
        //     switch (type) {
        //         case 'query':
        //             this.operate = {
        //                 show: true,
        //                 id: params,
        //                 title: "消息查看",
        //                 component: "compDetail",
        //                 width: 'large',
        //                 showFooter: false
        //             };
        //             break;
        //     }
        // },
        getOperateNodeMap(row) {
            const { id, } = row;
            return [
                {
                    label: this.$t('global.common.query'),
                    to: {
                        name: "basicdataCarrierUpdate",
                        params: {
                            type: 'query',
                        },
                        query: { id }
                    },
                    show: true
                },
                {
                    label: this.$t('global.common.edit'),
                    to: {
                        name: "basicdataCarrierUpdate",
                        params: {
                            type: 'edit',
                        },
                        query: { id }
                    },
                    show: true
                },
            ];
        },
    },
    computed: {
        // ...mapGetters('dictionary', ['getOrgList', 'getProductList', 'getWarehouseList']),

        ToolsData() {
            return [
                {
                    label:  this.$t('erp.product.new_add', { defaultValue: '添加' }),
                    theme: "primary",
                    to: {
                        name: "basicdataCarrierUpdate",
                        params: {
                            type: 'add'
                        }
                    }
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('fbb.carrieraccount.carrieraccount', { defaultValue: '承运商' }),
                    key: 'EQ_carrierCode',
                    tag: 'vInput',
                    show: true,
                },
                {
                    label: this.$t('fbb.basicdata.carrier_name', { defaultValue: '承运商名称' }),
                    key: 'CN_carrierName',
                    tag: 'vInput',
                    show: true,
                },
                {
                    label: this.$t('fbb.basicdata.carrier_active', { defaultValue: '启用状态' }),
                    key: 'EQ_active',
                    tag: 'vSelect',
                    show: true,
                    options: this.getActives,
                },
                {
                    label: this.$t('fbb.bill.freeze_createdat', { defaultValue: '创建日期' }),
                    tag: 'vDatepicker',
                    style: "width:200px",
                    key: 'BT_createdAt',
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                    },
                },
            ]
        },
        columns() {
            return [
                {
                    title:  this.$t('global.common.actions', { defaultValue: '操作' }),
                    width: 100,
                    render: this.getOperateNodes
                },
                {
                    title: this.$t('fbb.carrieraccount.carrieraccount', { defaultValue: '承运商' }),
                    key: 'carrierCode',
                },
                {
                    title: this.$t('fbb.basicdata.carrier_name', { defaultValue: '承运商名称' }),
                    key: 'carrierName',
                },
                {
                    title: this.$t('fbb.basicdata.carrier_active', { defaultValue: '启用状态' }),
                    key: 'active',
                    render: (h, { row }) => this.findRenderLabel(this.getActives, row.active),
                },
                {
                    title: this.$t('fbb.adjustment.created_name', { defaultValue: '创建人' }),
                    key: 'createdName',
                },
                {
                    title: this.$t('global.common.createdtime', { defaultValue: '创建时间' }),
                    key: 'createdAt',
                }];
        },
    },
};




